import { useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  const processSession = useCallback(async () => {
    try {
      const hash = location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      const response = await axios.post(`${API}/auth/google`, { session_id: sessionId }, {
        withCredentials: true
      });

      // Navigate to dashboard with user data
      navigate('/dashboard', { state: { user: response.data }, replace: true });
    } catch (error) {
      // Auth error - redirect to login
      navigate('/login');
    }
  }, [navigate, location.hash]);

  useEffect(() => {
    // CRITICAL: Use useRef to prevent double processing under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    processSession();
  }, [processSession]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted-foreground">Authentification en cours...</p>
      </div>
    </div>
  );
}